import type { RhythmSessionStats } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import type { RhythmSubMode } from './rhythm-trainer-params.js'
import styles from './rhythm-trainer-summary.module.css'

const SUB_MODE_LABEL: Record<RhythmSubMode, string> = {
  meter: 'Meter ID',
  subdivision: 'Subdivision ID',
  grouping: 'Grouping ID',
}

export interface RhythmTrainerSummaryProps {
  subMode: RhythmSubMode
  stats: RhythmSessionStats
  onRestart: () => void
  onSwitchMode: (lastSubMode: RhythmSubMode) => void
}

/**
 * Rhythm Trainer end-of-session summary. Mirrors `EarTrainingSummary`:
 * sub-mode label + score + Restart + Switch-sub-mode CTAs. Switching always
 * re-enters the welcome screen with the *other* card pre-selected.
 *
 * Spec: docs/superpowers/specs/2026-05-22-rhythm-trainer-v1-design.md §6.4
 */
export const RhythmTrainerSummary: FC<RhythmTrainerSummaryProps> = props => {
  const { subMode, stats, onRestart, onSwitchMode } = props
  return (
    <section className={styles.summary} aria-label="Session complete">
      <h2 className={styles.title}>Session complete</h2>
      <p className={styles.subMode}>{SUB_MODE_LABEL[subMode]}</p>
      <p className={styles.score}>
        {stats.correct} / {stats.total}
      </p>
      <div className={styles.actions}>
        <Button variant="contained" color="primary" size="large" onClick={onRestart}>
          Start new session
        </Button>
        <Button variant="outlined" size="large" onClick={() => onSwitchMode(subMode)}>
          Try other sub-mode
        </Button>
      </div>
    </section>
  )
}
